var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BC1D9970-1CEA-4D5C-AA4A-5E2A232DE64C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A74E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6FE6",
    offset: "31.4717061%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D69EA",
    offset: "66.8206292%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8358ED",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(-16.000000, -16.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4133333,16 L37.4133333,23.9226667 L26.5893333,23.9226667 L26.5893333,16 L23.9226667,16 L23.9226667,23.9226667 L16,23.9226667 L16,26.5893333 L23.9226667,26.5893333 L23.9226667,37.4133333 L16,37.4133333 L16,40.0786667 L23.9226667,40.0786667 L23.9226667,48 L26.5893333,48 L26.5893333,40.0786667 L37.4133333,40.0786667 L37.4133333,48 L40.08,48 L40.08,40.0786667 L48.0013333,40.0786667 L48.0013333,37.4133333 L40.08,37.4133333 L40.08,26.5893333 L48.0013333,26.5893333 L48.0013333,23.9226667 L40.08,23.9226667 L40.08,16 L37.4133333,16 Z M26.5893333,37.4133333 L37.4133333,37.4133333 L37.4133333,26.5893333 L26.5893333,26.5893333 L26.5893333,37.4133333 Z",
    id: "Fill-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/hashtag.6255f66cce6298aac525d14e8168955f.svg";
export { ForwardRef as ReactComponent };